<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Store Third ID"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`7- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Name</th>
              <th scope="col">Zone</th>
              <th scope="col">StoreID</th>
              <th scope="col">Language</th>
              <th scope="col">Overwrite Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="storeOverwritten in storesOverwritten"
              v-if="isStoreFiltered(storeOverwritten)"
            >
              <td>{{ storeOverwritten.id }}</td>
              <td>{{ storeOverwritten.name }}</td>
              <td>{{ storeOverwritten.zone }}</td>
              <td>{{ storeOverwritten.thirdIdStore }}</td>
              <td>{{ storeOverwritten.language }}</td>
              <td>{{ storeOverwritten.overwriteDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../../parameters";
import { httpClient } from "../../../requesters/httpClient";

export default {
  name: "Stores",
  data() {
    return {
      storesOverwritten: [],
      id: "7",
      sub_id: null,
      third_id_filtered: "7--",
    };
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/store-overwrittens`)
      .then((response) => {
        this.storesOverwritten = response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id == null ? "" : this.sub_id;
      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
    },
    isStoreFiltered: function (store) {
      return (
        this.third_id_filtered === "7--" ||
        this.third_id_filtered === store.thirdIdStore
      );
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/overwritten/stores/Stores.vue